import Grid from '@mui/material/Grid2';
import { LeftColumnSkeleton } from '../Skeletons';
import AgentBusinessCard from './components/AgentBusinessCard';
import SignalsPanel from './components/SignalsPanel';
import SystemSentimentPanel from './components/SystemSentimentPanel';

type SignalData = {
  sentiment?: string;
  severity?: string;
};

export default function LeftColumn({
  isAgencyView,
  isLoading,
  leftColumnSx,
  agentName,
  businessName,
  signalData,
  keywords,
  workflows,
  taskCompleted,
  systemSentiments
}: {
  isAgencyView: boolean;
  isLoading: boolean;
  leftColumnSx: object;
  agentName: string;
  businessName: string;
  signalData: SignalData;
  keywords: string[];
  workflows: string[];
  taskCompleted: string[];
  systemSentiments?: { label: string; description: string }[];
}) {
  return (
    <Grid size={{ xs: 12, lg: 3 }} sx={leftColumnSx}>
      {isLoading ? (
        <LeftColumnSkeleton />
      ) : (
        <>
          {isAgencyView && <AgentBusinessCard agentName={agentName} businessName={businessName} />}
          <SignalsPanel
            signalData={signalData}
            keywords={keywords}
            workflows={workflows}
            taskCompleted={taskCompleted}
          />
          {isAgencyView && <SystemSentimentPanel auditIssues={systemSentiments} />}
        </>
      )}
    </Grid>
  );
}
